import { TemplateRef } from '@angular/core';
import { CoreModel } from '../core/core.model';
import { IconModel } from '../icon/icon.model';
export class AlertModel extends CoreModel {
/**
 * Alert id. Optional, but must be set for correct work with alerts actions events.
 */
id?: string;
/**
 * Optional content section.
 */
content?: {
    /**
     * Title of alert.
     */
    title?: string;
    /**
     * Message of alert.
     */
    message?: string;
    /**
     * Alert html ng-template name.
     */
    templateName?: string;
  }
/**
 * Alert position. Can be: top-left, top-right, bottom-left, bottom-right. Default: top-right.
 */
position?: string;
/**
 * Alert timeout
 */
timeOut?: number;
/**
 * Alert timeout after hover on alert.
 */
extendedTimeOut?: number;
/**
 * Optional inform section.
 */
inform?: {
    /**
     * If to show inform icon
     */
    show?: boolean;
    /**
     * Alert inform icon model. Default must be specified in corresponding template.
     */
    icon?: IconModel;
  };
/**
 * Optional cancel section.
 */
cancel?: {
    /**
     * If to show cancel icon
     */
    show?: boolean;
    /**
     * Alert cancel icon model. Default must be specified in corresponding template.
     */
    icon?: IconModel;
  };
/**
 * Optional confirm section.
 */
confirm?: {
    /**
     * If to show confirm icon
     */
    show?: boolean;
    /**
     * Alert confirm icon model. Default must be specified in corresponding template.
     */
    icon?: IconModel;
  }
/**
 * If to show progressBar
 */
progressBar?: boolean;
/**
 * ProgressBar animation: increasing/decreasing. Default: decreasing.
 */
progressAnimation?: string;
/**
 * Class for alert title
 */
autoDismiss?: boolean;
/**
 * Maximum number of alerts opened
 */
maxOpened?: number;
/**
 * If to open newest alert on top of other alerts
 */
newestOnTop?: boolean;
/**
 * Fire ApplicationRef.tick() from the toast component when activated. Helps show toast from a websocket event.
 */
onActivateTick?: boolean;
/**
 * Close on click
 */
tapToDismiss?: boolean;
/**
 * To prevent duplicates
 */
preventDuplicates?: boolean;
/**
 * @hidden
 * @param {?=} values
 */
constructor(values: Object = {}) {
    super(values);
    Object.assign(this, values);
  }
}

function AlertModel_tsickle_Closure_declarations() {
/**
 * Alert id. Optional, but must be set for correct work with alerts actions events.
 * @type {?}
 */
AlertModel.prototype.id;
/**
 * Optional content section.
 * @type {?}
 */
AlertModel.prototype.content;
/**
 * Alert position. Can be: top-left, top-right, bottom-left, bottom-right. Default: top-right.
 * @type {?}
 */
AlertModel.prototype.position;
/**
 * Alert timeout
 * @type {?}
 */
AlertModel.prototype.timeOut;
/**
 * Alert timeout after hover on alert.
 * @type {?}
 */
AlertModel.prototype.extendedTimeOut;
/**
 * Optional inform section.
 * @type {?}
 */
AlertModel.prototype.inform;
/**
 * Optional cancel section.
 * @type {?}
 */
AlertModel.prototype.cancel;
/**
 * Optional confirm section.
 * @type {?}
 */
AlertModel.prototype.confirm;
/**
 * If to show progressBar
 * @type {?}
 */
AlertModel.prototype.progressBar;
/**
 * ProgressBar animation: increasing/decreasing. Default: decreasing.
 * @type {?}
 */
AlertModel.prototype.progressAnimation;
/**
 * Class for alert title
 * @type {?}
 */
AlertModel.prototype.autoDismiss;
/**
 * Maximum number of alerts opened
 * @type {?}
 */
AlertModel.prototype.maxOpened;
/**
 * If to open newest alert on top of other alerts
 * @type {?}
 */
AlertModel.prototype.newestOnTop;
/**
 * Fire ApplicationRef.tick() from the toast component when activated. Helps show toast from a websocket event.
 * @type {?}
 */
AlertModel.prototype.onActivateTick;
/**
 * Close on click
 * @type {?}
 */
AlertModel.prototype.tapToDismiss;
/**
 * To prevent duplicates
 * @type {?}
 */
AlertModel.prototype.preventDuplicates;
}

